import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import PageTitle from "../base/PageTitle";
import Setup from "../views/Setup";
import { useDispatch } from "../../store";
import { getCompany, setNewCompany } from "../../slices/company";

interface Props {}

const NewCompanyPage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setNewCompany(true));
    dispatch(getCompany(undefined));
  }, [dispatch]);

  return (
    <Box>
      <PageTitle title="New Company" />
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignContent="center"
        justifyItems="center"
        alignItems="center"
        paddingX={30}
        paddingBottom={5}
      >
        <Typography variant="h4" textAlign="center">
          Enter information below to create a new company that has its own
          settings and user list.
        </Typography>
      </Box>
      <Setup />
    </Box>
  );
};

export default NewCompanyPage;
